var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLlmInferenceApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 454,
    viewBox: "0 0 501 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5129 192H0.512695V96.5C1.53821 71.5 24.1251 3 102.064 0.5H194.513V40L108.73 40.4999C81.5537 40.5 45.6149 56.4999 41.5129 99.9999V192Z",
    fill: "#64B4D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M457.001 297L500.001 297L500 357C498.975 382 475.388 450.5 397.449 453L305 453L305 411.5L392.783 412C419.959 412 452.898 397 457 353.5L457.001 297Z",
    fill: "url(#paint0_linear_8_82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M497.794 262H484.294C476.794 262 460.098 259.275 455.698 240.075C455.31 238.383 455.294 236.629 455.294 234.893L455.296 192L455.294 101C451.294 57.5 417.294 41.5001 390.794 41.5L302.294 41L231.294 41L231 25.3879C231.434 16.1183 237.294 1.00001 251.794 8.32794e-06H253.294L402.849 4.1559e-06C427.704 0.997435 495.808 23.4396 498.294 99.2442V193.5V194V261.5V262H497.794Z",
    fill: "url(#paint1_linear_8_82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344.294 349.612L344 334L272 334L183.5 333.5L120 333L120 274L119.998 183L120 137.5L119.596 76L116.577 76C113.197 76 109.781 76.1381 106.605 77.2968C97.9807 80.4438 85.5987 89.003 79 105.5C78.3365 107.822 78 110.225 78 112.64L78 113L78 147L78.5 317.5C78.5919 325.409 78.3317 332.986 79 339C82 359 100.907 373.854 117 374.5L320.5 375C335 374 345.5 359 344.294 349.612Z",
    fill: "url(#paint2_linear_8_82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 110V117L304 296H344V117.717L379.889 118V177L379.891 268L379.889 313.5L379.889 374.5H383.423C386.803 374.5 390.217 374.362 393.405 373.237C402.002 370.204 414.295 361.985 420.889 345.5C421.552 343.178 421.889 340.775 421.889 338.36V338V304L421.389 133.5C421.297 125.591 421.557 118.014 420.889 112C417.889 91.9999 397.5 77 384 76L339 76C317 76.4999 304.294 100 304.294 110Z",
    fill: "url(#paint3_linear_8_82)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.002 196.5L156 105.5V77H194.541L195 232.5L195 265C195 265 195.014 265.914 195 266.5C194.981 267.327 194.891 268.238 194.759 269.167C194.006 274.467 192.269 279.665 189.367 284.162C183.107 293.862 175.056 295.325 168.549 295.977C165.186 296.314 161.803 296.5 158.423 296.5H156.404L156 242L156.002 196.5Z",
    fill: "url(#paint4_linear_8_82)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50002 230L16 230L42.9998 230L42.9998 253.5L42.9976 299L43 352C47 395.5 79 413.5 105.5 413.5L195 413L270.5 413L270.5 427.5C270.066 436.77 263 452 248.5 453L247 453L95.4452 453C70.5897 452.003 4.48554 429.56 2.00001 353.756L2.00001 297.5L2.00001 297L2.00002 230.5L2.00002 230L2.50002 230Z",
    fill: "#01295D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231 77H270V296H231V77Z",
    fill: "url(#paint5_linear_8_82)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_82",
    x1: 481,
    y1: 300,
    x2: 307,
    y2: 437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377472,
    stopColor: "#2F6795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#487BA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_82",
    x1: 253.5,
    y1: -0.00000435435,
    x2: 491.5,
    y2: 252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CE5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47919,
    stopColor: "#D3FCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_82",
    x1: 110,
    y1: 82,
    x2: 332,
    y2: 371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644905,
    stopColor: "#1A5F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2475A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_82",
    x1: 362.944,
    y1: 76,
    x2: 362.944,
    y2: 374.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BE4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212743,
    stopColor: "#5AAECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453159,
    stopColor: "#3B8EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E8EB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_82",
    x1: 187,
    y1: 104,
    x2: 175.003,
    y2: 296.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2778A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D6E9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_82",
    x1: 251,
    y1: 77,
    x2: 251,
    y2: 296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E82AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlmInferenceApp);
export default __webpack_public_path__ + "static/media/llm-inference-app.e7d2912001eb047acb2d304e057fc649.svg";
export { ForwardRef as ReactComponent };